const ensureNonEmptyString = (value, fieldName) => {
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(`${fieldName} must be a non-empty string`);
  }
  return value.trim();
};

const normalizeLineNumber = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || !Number.isInteger(parsed)) {
    return 0;
  }
  return Math.max(0, parsed);
};

export const buildValidationError = (type, message, lineNumber) => ({
  type: ensureNonEmptyString(type, 'type'),
  message: ensureNonEmptyString(message, 'message'),
  lineNumber: normalizeLineNumber(lineNumber),
});

export const buildFileSizeError = (maxSizeMb) => buildValidationError(
  'FILE_TOO_LARGE',
  `File exceeds ${maxSizeMb}MB limit.`,
  0,
);
